import styled from 'styled-components';
import { UIView } from '../../../utils/styled/styled';

export const Components = {
  RightSideContainer: styled(UIView)`
    width: 100%;
    height: 100vh;
    max-height: 100vh;
    overflow: hidden;
  `,
  ChildrenWrapper: styled.div`
    position: relative;
    display: flex;
    width: 100%;
    height: 100vh;
    overflow-y: auto;
  `,
};
